// extracted by css-extract-rspack-plugin
export default {"noResults":"_26bd5cd9"};